export default __webpack_public_path__ + "static/media/home2.1a7086a7.jpg";